import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App, prefetchScreens, warmStart } from './App';
import { initMonitoring } from './lib/analytics';
import { initTelegram } from './telegram';
import './index.css';

initTelegram();
initMonitoring();
warmStart();

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root is missing');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
prefetchScreens();
